import { useState } from "react";

/**
 * @template { (...args: any[]) => Promise<any> } T
 * @param { T } promise
 * @returns { T }
 */
export function usePending(promise) {
  const [isPending, setIsPending] = useState(false);

  async function call(...args) {
    setIsPending(true);
    return promise(...args)
      .then(res => {
        setIsPending(false);
        return res;
      })
      .catch(err => {
        setIsPending(false);
        throw err;
      });
  }

  call.isPending = isPending;

  return call;
}
